import { Round } from '../models/round';
import { RecentRound } from '../models/recent-round';
import { addDays } from 'date-fns';

class RecentRoundsService {
    public getRecentRounds() {
        const data = localStorage.getItem('recentRounds');
        if (!data) return [];
        const recentRounds =  JSON.parse(data) as RecentRound[];
        return recentRounds.filter(r => {
            if (!r.expiresAt) return false;
            const expireDate = new Date(r.expiresAt);
            return expireDate > new Date();
        });
    };

    public updateRecentRounds(roundId: string, roundName: string, roundDate: string, playerId: string, playerName: string, expiresAt: string) {
        const recentRound = {
            roundId,
            roundName,
            roundDate,
            playerId,
            playerName,
            expiresAt,
        }
        const existing = this.getRecentRounds();
        const filtered = existing.filter(r => r.roundId !== roundId);
        const updated = [recentRound, ...filtered].slice(0, 10);
        localStorage.setItem('recentRounds', JSON.stringify(updated));
    };
}

export const recentRoundsService = new RecentRoundsService();